import { z } from "zod";

export const EtlMessageSchema = z.object({
	etl_message: z.string()
});

export type EtlMessage = z.infer<typeof EtlMessageSchema>;
